import styled from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justify || "initial"};
  padding: ${props => props.padding || "1em"};
  align-items: ${props => props.alignitems};
  color: ${props => props.color};
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  width: ${props => props.width || "auto"};
  @media (max-width: 600px) {
    display: ${props => props.display};
  }
`;
